<div class="basicarticle-editor" *ngIf="manageBasicArticlePermitted">

  <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
      <sc-dialog-title>
          {{ 'Basisartikel' | translate: ['erp.ui.basicarticle-editor.title', translationService.language]}}
          <sc-content-spacer></sc-content-spacer>
      </sc-dialog-title>

      <app-service-response [responseMessages]="responseMessages"></app-service-response>

      <sc-content-spacer [vertical]="true"></sc-content-spacer>

      <sc-separator-line></sc-separator-line>

      <sc-bordered-tile>
        <sc-padding>
          <app-basicarticle-articletype [basicArticle]="selected"></app-basicarticle-articletype>
          <form [formGroup]="formGroup" class="no-field-space">
            <mat-checkbox name="archived" formControlName="archived">
              {{'archived' | translate: ['erp.entity.basicarticle.archived', translationService.language]}}
            </mat-checkbox>
          </form>
        </sc-padding>
      </sc-bordered-tile>

      <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

        <sc-scroll-pane>
          <sc-bordered-tile>
            <sc-padding>
              <app-basicarticle-attributes [formGroup]="formGroup" [basicArticle]="selected"></app-basicarticle-attributes>
            </sc-padding>
          </sc-bordered-tile>

          <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

          <sc-bordered-tile>
            <sc-padding>
              <sc-sub-title>
                  {{ 'Verkaufspreise' | translate: ['erp.ui.basicarticle-editor.subtitle.retailprices', translationService.language]}}
                  <sc-content-spacer [grow]="true"></sc-content-spacer>
                  <button mat-stroked-button (click)="addRetailPrice()">
                      <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                      {{ 'Verkaufspreise' | translate: ['erp.ui.basicarticle-editor.action.add-retailprice', translationService.language]}}
                  </button>
              </sc-sub-title>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <div class="tablecontainer">
                <table mat-table [dataSource]="retailPricesDataSource" matSort (matSortChange)="announceSortChange($event)">

                    <ng-container matColumnDef="valid-from">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by valid-from">
                            {{ 'Von' | translate: ['erp.ui.basicarticle-editor.table.retailprice.valid-from', translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-selection"> {{element.validPeriod?.from  | date: 'dd.MM.yyyy'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="valid-until">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by valid-until">
                            {{ 'Bis' | translate: ['erp.ui.basicarticle-editor.table.retailprice.valid-until', translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-selection"> {{element.validPeriod?.until  | date: 'dd.MM.yyyy'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="price-net">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by weight">
                            {{ 'Netto' | translate: ['erp.ui.basicarticle-editor.table.retailprice.price-net', translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-selection"> {{element.priceNet | numberFormat:priceScale}} </td>
                    </ng-container>

                    <ng-container matColumnDef="tax-rate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by symbol">
                            {{ 'Steuersatz' | translate: ['erp.ui.basicarticle-editor.table.retailprice.tax-rate', translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-selection"> {{element.taxRate}} </td>
                    </ng-container>

                    <ng-container matColumnDef="price-vat">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by symbol">
                            {{ 'Brutto' | translate: ['erp.ui.basicarticle-editor.table.retailprice.price-vat', translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-selection"> {{element.priceVat | numberFormat:priceScale}} </td>
                    </ng-container>

                    <ng-container matColumnDef="reference-date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by symbol">
                            {{ 'Datum' | translate: ['erp.ui.basicarticle-editor.table.retailprice.referencedate', translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-selection"> {{element.referenceDate}} </td>
                    </ng-container>

                    <ng-container matColumnDef="commands">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button (click)="editRetailPrice(element)"><sc-icon
                                    class="fa-light fa-pencil"></sc-icon></button>
                            <button mat-icon-button (click)="removeRetailPrice(element)"><sc-icon iconClass="fa-trash"></sc-icon></button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="retailPricesDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: retailPricesDisplayedColumns;"></tr>
                </table>
              </div>
            </sc-padding>
          </sc-bordered-tile>

        </sc-scroll-pane>
        <sc-content-spacer [vertical]="true" [grow]="true"></sc-content-spacer>

      <sc-separator-line></sc-separator-line>
      <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onCancel()">
          <mat-icon><sc-icon iconClass="fa-xmark"></sc-icon></mat-icon>
          {{ 'abbrechen' | translate: ['erp.ui.basicarticle-editor.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onSave()" [disabled]="saveDisabled">
            <mat-icon><sc-icon iconClass="fa-save"></sc-icon></mat-icon>
            {{ 'speichern' | translate: ['erp.ui.basicarticle-editor.action.confirm', translationService.language]}}
        </button>
      </sc-actionbar>

  </sc-flex>

</div>
